//LoginPage.jsx
import React, { useEffect , useState} from 'react';
import { useAuth } from 'react-oidc-context';
import { useNavigate } from 'react-router-dom';
import { Button, View, Heading } from '@aws-amplify/ui-react';
import '../styles/LoginPage.scss';

const LoginPage = () => {
  const auth = useAuth();
  const navigate = useNavigate();


  // If already signed in, go to dashboard
  useEffect(() => {
    if (auth.isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);



  return (
    <View className="authenticator-glassmorphism" padding="2rem">
      <Button className='lp-btn' onClick={() => auth.signinRedirect()}>
        Sign in with your Identity Provider
      </Button>
    </View>
  );
};

export default LoginPage;
